import React from 'react';

import styled from 'styled-components';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const Terms = styled.div`
    a.link:link,
    a.link:visited {
        text-decoration: none;
        color: ${(props) => props.theme.black};
    }
`;

const PreCheckTerms = () => {
    const { precheckTerms } = usePageMessages();

    return (
        <Row textAlign="center">
            <Terms>
                <DangerouslyHtml variant="div" type="text" size="secondary" color="secondary" dangerouslyHtml={precheckTerms} />
            </Terms>
        </Row>
    );
};
export default PreCheckTerms;
